module.exports = {versao:
62
, alt:true, app:"UnTaxi"
, base:"http://termos.untaxi.com.br"
, url:"https://s-api.untaxi.com.br"};
